/* lua.js generated code undefined */
 //	用户隐私协议概要（第一次进游戏强弹的那个）
require("clover/panel/component/common/UIGroupButton")
require("clover/ui/UIItemBuilder")
var ButtonPushBounceAnim = require("clover/panel/component/common/uiButtonAnims/PushBounceAnim")
require("clover/panel/base/BasePanel")
var instance = null
let [TextAreaWidth, TextAreaHeight] = [560, 620]



let sumPrivacyPanel = xClass("sumPrivacyPanel", BasePanel, function () {
    let __VA_ARG = $slice(arguments, 0)
    return cc.Node.create()
})

let _instance = null
sumPrivacyPanel.getInstance = function () {
    let self = this

    if (!instance) {
        instance = sumPrivacyPanel.new()
    }
    return instance
    
}
sumPrivacyPanel.prototype.ctor = function (agreeCb, disagreeCb) {
    let self = this
    self.privacy_config = PrivacyUtil.getPrivacy_config()
    self.isBusy = false 
    BasePanel.prototype.ctor.call(self);

    self.initUI(agreeCb, disagreeCb);
    self.initTxt()



}

sumPrivacyPanel.prototype.popup = function () {
    let self = this
    let size = cc.Director.getInstance().getVisibleSize()
	self.setPosition(size.width / 2, size.height / 2)

    //popup动画
    let actionList = table()
    table.insert(actionList, cc.CallFunc.create(function () {
        self.bg.setScale(0.1)
    }))
    table.insert(actionList, cc.EaseSineOut.create(cc.ScaleTo.create(0.2, 1)))
    self.bg.runAction(cc.Sequence.create(actionList))

    var curScene = cc.Director.getInstance().getRunningScene()
	curScene.addChild(self, 999)
	return self

}


sumPrivacyPanel.prototype.initUI = function (agreeCb, disagreeCb) {
    let self = this
    let bg = ccui.Scale9Sprite.createWithSpriteFrameName("commonLib/privacy_bg.png", cc.rect(20, 16, 16, 16))
    bg.setContentSize(cc.size(680, TextAreaHeight + 230))
    bg.setPosition(0,0)
    self.addChild(bg)
    self.bg = bg

    let white = ccui.Scale9Sprite.createWithSpriteFrameName("commonLib/privacy_white_bg.png", cc.rect(50, 50, 24, 24))
    white.setContentSize(cc.size(621, TextAreaHeight))
    white.setAnchorPoint(0.5, 1)
    white.setPosition(340, 150 + TextAreaHeight)
    self.bg.addChild(white)


    //同意按钮
    let agreebtn = ccui.Scale9Sprite.createWithSpriteFrameName("commonLib/privacy_miniagree_btn.png", cc.rect(32, 36, 1, 1))
    console.log("privacy agreebtn", agreebtn)
    agreebtn.setContentSize(cc.size(219, 90))
    agreebtn.setPosition(500, 70)
    self.bg.addChild(agreebtn)

    let label = cc.Label.createWithSystemFont("同意", "", 25)
    label.setTextColor(cc.c4b(255, 255, 255, 255))
    label.setPosition(110, 45)
    agreebtn.addChild(label)
    let uiButton = UIButton.create(agreebtn, true)
    uiButton.on(UIButtonEvent.Click, function(){
        self.onClose(agreeCb)
    })
    ButtonPushBounceAnim.create(uiButton)

    //不同意按钮
    let disagreebtn = ccui.Scale9Sprite.createWithSpriteFrameName("commonLib/privacy_agree_btn.png", cc.rect(32, 36, 1, 1))
    disagreebtn.setContentSize(cc.size(219, 90))
    disagreebtn.setPosition(160, 70)
    self.bg.addChild(disagreebtn)
    let label1 = cc.Label.createWithSystemFont("不同意", "", 25)
    label1.setTextColor(cc.c4b(255, 255, 255, 255))
    label1.setPosition(110, 45)
    disagreebtn.addChild(label1)
    let uiButton1 = UIButton.create(disagreebtn, true)
    uiButton1.on(UIButtonEvent.Click, function(){
        self.onClose(disagreeCb)
    })
    ButtonPushBounceAnim.create(uiButton1)

}

sumPrivacyPanel.prototype.initTxt = function () {
    let self = this

    self.titleTxt = self.privacy_config["privacy.summary.title"]
    self.contentTxt = self.privacy_config["privacy.summary.content"]
    self.contentTxt = self.contentTxt.replace(/\\t/g, "\t")
    self.contentTxt = self.contentTxt.replace(/\\n/g, "\n")
    

    let title = cc.Label.createWithSystemFont(self.titleTxt, "微软雅黑", 33)
    title.setTextColor(cc.c4b(57, 112, 145, 255))
    title.setPosition(340, TextAreaHeight + 180)
    self.bg.addChild(title)


    self.maxAgreementList = $len(self.contentTxt)
    self.scrollview = ccui.ScrollView.create()
    self.scrollview.setContentSize(cc.size(TextAreaWidth, TextAreaHeight- 40))
    self.scrollview.setPosition(cc.p(60, 180))
    self.scrollview.setDirection(ccui.ScrollViewDir.vertical)
    self.scrollview.setBounceEnabled(true)
    self.bg.addChild(self.scrollview)
    self.scrollview.setInnerContainerSize(cc.size(TextAreaWidth, TextAreaHeight))

    let node = cc.Label.createWithSystemFont(self.contentTxt, "微软雅黑", 25)
    node.setTextColor(cc.c4b(57, 112, 145, 255))
    node.setDimensions(TextAreaWidth, 0)
    node.setAnchorPoint(0, 1)
    node.setPositionY(TextAreaHeight - 20)
    self.scrollview.addChild(node)

    self.contentTxtLast = "为了更好地保护您的个人信息，建议您完整阅读"

    let labelL = cc.Label.createWithSystemFont(self.contentTxtLast, "微软雅黑", 25)
    labelL.setTextColor(cc.c4b(57, 112, 145, 255))
    labelL.setDimensions(TextAreaWidth, 0)
    labelL.setAnchorPoint(0, 1)
    labelL.setPositionY(TextAreaHeight + 25- node.getContentSize().height)
    self.scrollview.addChild(labelL)

    let label1 = cc.Label.createWithSystemFont("更新后的", "微软雅黑", 25)
    label1.setTextColor(cc.c4b(57, 112, 145, 255))
    label1.setAnchorPoint(0, 1)
    label1.setPositionY(labelL.y - labelL.getContentSize().height)
    self.scrollview.addChild(label1)

    //《用户协议》
    let labelNode = UIItemBuilder.createUnderlineText(self.privacy_config["privacy.user_agreement.id"], 25, cc.color(57, 112, 145, 255))

    let btn_user = UIButton.create(labelNode, true)
    btn_user.on(UIButtonEvent.Click, function() {
        if (self.isBusy){
            return
        }
        self.isBusy = true
        PrivacyUtil.openPrivacyPanel("userAgreement", function (){
            self.isBusy = false
        })

    })
    btn_user.setPosition(label1.x + label1.getContentSize().width, label1.y)
    btn_user.setAnchorPoint(0, 1)
    self.scrollview.addChild(btn_user)

    let label2 = cc.Label.createWithSystemFont("以及", "微软雅黑", 25)
    label2.setTextColor(cc.c4b(57, 112, 145, 255))
    label2.setAnchorPoint(0, 1)
    label2.setPosition(btn_user.x + btn_user.getContentSize().width, btn_user.y)
    self.scrollview.addChild(label2)


    //《隐私政策》
    let labelNode1 = UIItemBuilder.createUnderlineText(self.privacy_config["privacy.privacy_policy.id"], 25, cc.color(57, 112, 145, 255))
    
    let btn_policy = UIButton.create(labelNode1, true)
    btn_policy.on(UIButtonEvent.Click, function() {
        if (self.isBusy){
            return
        }
        self.isBusy = true

        PrivacyUtil.openPrivacyPanel("privacyPolicy", function (){
            self.isBusy = false
        })
    })
    btn_policy.setPosition(label2.x + label2.getContentSize().width, label2.y)
    btn_policy.setAnchorPoint(0, 1)
    self.scrollview.addChild(btn_policy)

}


module.exports = sumPrivacyPanel